<div class="wrapper--title" [ngClass]="field.customClass" [id]="field.id">
  <h3 [nxHeadline]="field.headline ?? ''">{{ field.titleText | translate }}</h3>

  <div *ngIf="field.text" [innerHTML]="field.text | translate"></div>
</div>
